export const FORM_WIDTH = 640;
